<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="标题">
      <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
    </t-form-item>
    <t-form-item label="图例字体">
      <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图例文字颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.legend.textStyle.color"/>
    </t-form-item>
    <e-collapse title="内边距" :expand="false">
        <t-form-item label="内边距(左)">
          <t-input-number size="small" v-model="attribute.grid.x" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(上)">
          <t-input-number size="small" v-model="attribute.grid.y" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(右)">
          <t-input-number size="small" v-model="attribute.grid.x2" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(下)">
          <t-input-number size="small" v-model="attribute.grid.y2" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
      </e-collapse>
    <e-collapse title="x轴" :expand="false">
      <t-form-item label="x轴文字">
        <t-switch v-model="attribute.xAxis.axisLabel.show"  :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="x轴字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.xAxis.axisLabel.color"/>
      </t-form-item>
      <t-form-item label="x轴线显示">
        <t-switch v-model="attribute.xAxis.axisLine.show"  :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="x轴线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.xAxis.axisLine.lineStyle.color"/>
      </t-form-item>
      <t-form-item label="x轴网格线">
        <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="x轴刻度线">
        <t-switch v-model="attribute.xAxis.axisTick.show"  :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="y轴" :expand="false">
      <t-form-item label="y轴文字">
        <t-switch v-model="attribute.yAxis.axisLabel.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="y轴字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.axisLabel.color"/>
      </t-form-item>
      <t-form-item label="y轴线显示">
        <t-switch v-model="attribute.yAxis.axisLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="y轴颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.yAxis.axisLine.lineStyle.color"/>
      </t-form-item>
      <t-form-item label="y轴网格线">
        <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="y轴刻度线">
        <t-switch v-model="attribute.yAxis.axisTick.show" :label="['开', '关']" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="气泡" :expand="true">
      <t-form-item label="数值自适应">
        <t-switch v-model="attribute.yAxis.scale" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="X轴Tip">
        <t-input size="small" v-model="attribute.xTip" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="Y轴Tip">
        <t-input size="small" v-model="attribute.yTip" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="气泡Tip">
        <t-input size="small" v-model="attribute.areaTip" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="配色">
        <e-color-group v-model="attribute.color" :max="20" :gradient="false"/>
      </t-form-item>
    </e-collapse>
    <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
       <t-switch v-model="attribute.dataZoom.show"/> 
    </t-form-item>
    <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
      <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0"/>
    </t-form-item> 
  </t-form>
</template>

<script>
import EColorGroup from "@/components/designer/e-color-group";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-scatter-option",
  components: {EColorGroup,CptData},
  props: {attribute: Object,cptDataForm:Object,},
}
</script>

<style scoped>
</style>
